export class Customer {
    public id: number;
    public name: string;
    public acronym: string;
    public countryId: number;
    public phone: string;
    public email: string;
    public foot1: string;
    public foot2: string;
    public chat: string;
    public whatsapp: string;
    public colour: string;
    public publicity: boolean;
    public policyData: boolean;
    public urlPolicy: string;
    public urlTyC: string;
    public sendInformation: boolean;
    public sendNotification: boolean;
    public typeCampaing: string;
    public campaing: string;
    public active: boolean;
    public country: string;
    public provincia: number;

    constructor() {}
}